import TsrSvgIcon, { Icon } from '../../assets/icons';
import { InputContainer } from '../InputContainer';
import { InputPropsBase } from '../interfaces/Inputs';
import { Label } from '../Label';
import { Underline } from '../Underline';
import { debounce, uniqueId } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import './styles.scss';

interface InputSearchProps extends InputPropsBase<string | undefined, string> {}

export function SearchInput(props: InputSearchProps) {
    const [searchText, setSearchText] = useState(props.value || '');
    const id = uniqueId('idSearchInput-');
    const onBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
        props.onChange && props.onChange(searchText);
        props.onBlur && props.onBlur(searchText);
    };
    const stateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchText(e.target.value);
    };
    const onChange = () => {
        props.onChange && props.onChange(searchText);
    };

    const clearInput = () => {
        setSearchText('');
        props.onChange && props.onChange('');
    };

    const delayedQuery = useCallback(debounce(onChange, 500), [searchText]);

    useEffect(() => {
        delayedQuery();
        return delayedQuery.cancel;
    }, [searchText, delayedQuery]);

    return (
        <InputContainer
            gap={props.gap}
            justify={props.justify}
            align={props.align}
            width={props.width}
            height={props.height}
            className={`${props.className} ${props.variant}`}
        >
            <Label
                id={props.id || id}
                content={props.label}
                disabled={props.disabled === true}
                labelPosition={props.labelPosition}
                labelLength={props.labelLength}
                className={props.labelClassName}
            >
                <div style={{ flex: props.inputLength || 1 }} className="tsr-input-search">
                    <input
                        type="text"
                        disabled={props.disabled === 'inputOnly' || props.disabled === true}
                        className={props.disabled === 'inputOnly' || props.disabled === true ? 'disabled' : ''}
                        value={searchText}
                        placeholder={props.placeholder}
                        autoComplete="new-password"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        id={props.id}
                        onClick={props.onClick}
                        onChange={stateChange}
                        onBlur={onBlur}
                    />
                    <div
                        className={`icons-container ${props.disabled ? 'disabled' : ''}`}
                        style={{ paddingRight: props.variant ? 5 : 0 }}
                    >
                        {searchText.length > 0 && (
                            <TsrSvgIcon icon={Icon.Close} onClick={() => !props.disabled && clearInput()} />
                        )}
                        <TsrSvgIcon icon={Icon.Search} />
                    </div>
                    {!props.variant && <Underline disabled={props.disabled === 'inputOnly' || props.disabled === true} />}
                </div>
            </Label>
        </InputContainer>
    );
}
